import React from 'react';
import ReactDOM from 'react-dom/client';
import HangtagDesigner from './hangtag-designer';

// Kök elementi alın
const rootElement = document.getElementById('hangtag-designer-root');

// Eğer kök element varsa, uygulamayı render et
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <HangtagDesigner />
        </React.StrictMode>
    );
} else {
    console.error('Root element #hangtag-designer-root not found');
}